import StyledGlobal from '@tmh-website/styles/global';
import StyledTypo from '@tmh-website/styles/typo';
import styled, { css } from 'styled-components';
import { ContactCardThemeColor, contactCardThemes } from './ContactCard.theme';

export const Container = styled.div<{ $themeColor: ContactCardThemeColor; $display?: 'form' | 'contact' }>`
  height: fit-content;
  overflow: hidden;
  color: ${props => props.theme.color[contactCardThemes[props.$themeColor].text]};
  border-radius: ${props => props.theme.borderRadius.medium};

  ${props =>
    props.$display === 'form' &&
    css`
      width: 100%;
      @media (${props => props.theme.breakpoint.xl.up}) {
        min-width: 690px;
      }
    `};

  ${props =>
    props.$display === 'contact' &&
    css`
      min-width: 190px;
    `};
`;

export const ContactCard = styled.div<{ $hasForm: boolean; $hasContact: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.gap.xSmall};
  justify-content: space-between;

  ${props =>
    props.$hasForm &&
    props.$hasContact &&
    css`
      @media (${props.theme.breakpoint.lg.up}) {
        flex-direction: row;
      }
    `};
`;

export const TopBar = styled.div<{ $themeColor: ContactCardThemeColor }>`
  padding: 7px ${props => props.theme.wrapperPaddingMobile} 6px;
  color: ${props => props.theme.color[contactCardThemes[props.$themeColor].topBarText]};
  background-color: ${props => props.theme.color[contactCardThemes[props.$themeColor].topBarBackground]};
  @media (${props => props.theme.breakpoint.xl.up}) {
    padding: 8px 24px 7px;
  }
`;

export const BottomBar = styled.div<{
  $themeColor: ContactCardThemeColor;
  $display?: 'form' | 'contact';
}>`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.gap.xSmall};
  justify-content: space-between;
  padding: 16px ${props => props.theme.wrapperPaddingMobile} 22px;
  background-color: ${props => props.theme.color[contactCardThemes[props.$themeColor].background]};
  @media (${props => props.theme.breakpoint.xl.up}) {
    padding: ${props => props.theme.wrapperPadding};
  }

  ${props =>
    props.$display === 'form' &&
    css`
      padding: ${props => props.theme.wrapperPadding} 0;
      @media (${props => props.theme.breakpoint.xl.up}) {
        padding: ${props => props.theme.wrapperPadding} 0;
      }

      ${StyledGlobal.WrapperSmall} {
        max-width: none;
      }
    `};

  ${props =>
    props.$display === 'contact' &&
    css`
      flex-direction: row;
      gap: ${props => props.theme.gap.small};

      @media (${props => props.theme.breakpoint.lg.up}) {
        flex-direction: column;
      }
    `};
`;

export const TelLink = styled(StyledTypo.Typography)<{ $themeColor: ContactCardThemeColor }>`
  margin: 3px 0;
  color: ${props => props.theme.color[contactCardThemes[props.$themeColor].textLink]};
  white-space: nowrap;
  transition: opacity ${props => props.theme.transitionTiming};
  &:hover {
    text-decoration: none;
    opacity: 0.8;
  }
`;
